import React from 'react';

const CancelCheckout = () => <p>cancel checkout page</p>

export default CancelCheckout;
